module.exports = __webpack_public_path__ + "static/media/innovations.d6b58e84.svg";